import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../../../../environments/environment';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {ServerDataSource} from '@mominsamir/ngx-smart-table';

@Injectable()
export class HttpService {
    // Interceptor-free client for third-party (S3) origins: the app bearer token and cancel header must not
    // reach them.
    private readonly rawHttp: HttpClient;

    constructor(private http: HttpClient, backend: HttpBackend) {
        this.rawHttp = new HttpClient(backend);
    }

    get apiUrl(): string {
        return environment.NODE_API_URL;
    }

    get(endpoint: string, options?): Observable<any> {
        return this.http.get(`${this.apiUrl}/${endpoint}`, options);
    }

    post(endpoint: string, data?, options?): Observable<any> {
        return this.http.post(`${this.apiUrl}/${endpoint}`, data, options);
    }

    put(endpoint: string, data?, options?): Observable<any> {
        return this.http.put(`${this.apiUrl}/${endpoint}`, data, options);
    }

    delete(endpoint: string, options?): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${endpoint}`, options);
    }

    uploadS3(endpoint: string, data?: any, options?: any): Observable<any> {
        return this.http.put(`${endpoint}`, data, options);
    }

    // Presigned URL is the only auth: no credentials, no app interceptors. Rethrows without the URL so the
    // signature never reaches logs or Datadog RUM.
    downloadS3(url: string): Observable<Blob> {
        return this.rawHttp
            .get(url, {responseType: 'blob', withCredentials: false})
            .pipe(
                catchError((e: HttpErrorResponse) =>
                    throwError(new Error(`S3 media fetch failed (${e.status || 'network'})`)),
                ),
            );
    }

    getServerDataSource(endpoint: string, method: string = 'get', req: any = null): Observable<DataSource> {
        return of(
            new ServerDataSource(this.http, {
                endPoint: `${this.apiUrl}/${endpoint}`,
                totalKey: 'totalCount',
                dataKey: 'items',
                pagerPageKey: 'pageNumber',
                pagerLimitKey: 'pageSize',
                filterFieldKey: 'filterBy#field#',
                sortFieldKey: 'sortBy',
                sortDirKey: 'orderBy',
                method: 'get',
                req: null,
            }),
        );
    }

    postServerDataSource(endpoint: string, req: any): Observable<DataSource> {
        return of(
            new ServerDataSource(this.http, {
                endPoint: `${this.apiUrl}/${endpoint}`,
                totalKey: 'totalCount',
                dataKey: 'items',
                pagerPageKey: 'pageNumber',
                pagerLimitKey: 'pageSize',
                filterFieldKey: 'filterBy#field#',
                sortFieldKey: 'sortBy',
                sortDirKey: 'orderBy',
                method: 'post',
                req: req,
            }),
        );
    }
}
